module.exports = __webpack_public_path__ + "components/app-buttons/static/google-play-f8b8496964eb6519aca6642d741e3209.svg";